import { useQuery, UseQueryResult } from 'react-query';
import {
  TemplateDueDatePayload,
  TemplateDueDateResponse,
  TemplatesAPI,
} from 'data/templates/api';

const useTemplateDueDateQuery = (
  payload: Partial<TemplateDueDatePayload>,
): UseQueryResult<TemplateDueDateResponse, unknown> => {
  return useQuery<
    TemplateDueDateResponse,
    unknown,
    TemplateDueDateResponse,
    [string, Partial<TemplateDueDatePayload>]
  >(
    ['template-due-date', payload],
    () => TemplatesAPI.getDueDate(payload as TemplateDueDatePayload),
    {
      enabled: payload.templateId != null && payload.startDate != null,
    },
  );
};

export { useTemplateDueDateQuery };
